type StoreLikeT<S> = {
  getState: () => S
  setState: (state: S, replace: true) => void
}

const resetters: (() => void)[] = []

/**
 * Snapshots a store's pristine state when its module first evaluates, so sign-out can wipe
 * every user-scoped store without each store hand-maintaining a duplicate initial state.
 */
export const registerStoreReset = <S>(store: StoreLikeT<S>) => {
  const initialState = store.getState()
  resetters.push(() => store.setState({ ...initialState }, true))
}

export const resetAllStores = () => {
  for (const reset of resetters) reset()
}
